import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { INE_REQUEST_START_LOADING, INE_REQUEST_END_LOADING, INE_REQUEST_LOADED, INE_REQUEST_SEARCH_START_LOADING, INE_REQUEST_SEARCH_END_LOADING, INE_REQUEST_SEARCH_LOADED, SET_INE_REQUEST_FILTER } from "../constants/IneRequestConstants";

const initialState = {
    loading: false,
    loadingFBO: false,
    fbo: null,
    list: {
        dataList: [],
        searchList: [],
        totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
    }
};

const IneRequestReducer = (state = initialState, action) => {
    switch(action.type) {
        case INE_REQUEST_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case INE_REQUEST_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case INE_REQUEST_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        case INE_REQUEST_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case INE_REQUEST_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case INE_REQUEST_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_INE_REQUEST_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        default:
            return state;
    }
}

export default IneRequestReducer;
